
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSatelliteLow as ObiSatelliteLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-satellite-low.js';
 
 
 

 
 export const ObiSatelliteLow = createComponent({
   react: React,
   tagName: 'obi-satellite-low',
   elementClass: ObiSatelliteLowElement,
   events: {
     
   }
  });
 
 